import { cn } from '../../utils/cn'
import { UserAvatar } from './user-avatar'

interface UserLabelProps {
  name: string
  /** The person's picture — the `avatar` field on any user-shaped payload. */
  src?: string | null
  className?: string
  avatarClassName?: string
  /**
   * Initials size. Defaults to `text-[10px]`, which suits the `size-5` avatar;
   * the fallback does not scale on its own, so pass a larger value whenever you
   * pass a larger `avatarClassName`.
   */
  fallbackClassName?: string
}

/**
 * Avatar + name on one line — how a person is named in a table cell, a select
 * item or a card. Keeps the picture and the name from drifting apart across
 * the app; for the picture alone use {@link UserAvatar}.
 */
export function UserLabel({ name, src, className, avatarClassName, fallbackClassName }: UserLabelProps) {
  return (
    <span className={cn('flex min-w-0 items-center gap-2', className)}>
      <UserAvatar
        name={name}
        src={src}
        className={cn('size-5', avatarClassName)}
        fallbackClassName={cn('text-[10px]', fallbackClassName)}
      />
      <span className="truncate">{name}</span>
    </span>
  )
}
